import clsx from "clsx";
import { type HTMLAttributes } from "react";
import { forwardRef } from "react";

import styles from "./actions.module.css";

type Props = HTMLAttributes<HTMLDivElement>;

const Actions = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { className, ...otherProps } = props;

    return <div {...otherProps} ref={ref} className={clsx(styles.actions, className)} />;
});

Actions.displayName = "Dialog.Content.Actions";

export { Actions as DialogContentActions };
export type { Props as DialogContentActionsProps };
